/* eslint-disable no-useless-escape */
import axios from "axios";

import { env } from "./env";
import IReviewRequest from "../types/IReviewRequest";
import IMileageRequest from "../types/IMileageRequest";
import IErrorRequest from "../types/IErrorRequest";
import IMissingRateRequest from "../types/IMissingRateRequest";
import { IRailFreightRateRequest } from "../types/IRailRateRequest";
import IPublishQuotedRailRateRequest from "../types/IPublishQuotedRailRate";

export default class NitroRequestService {
  private static readonly url = env.webApiBaseUrl;

  private static async post(
    endPoint: string,
    body: { [key: string]: any } | FormData,
  ): Promise<any> {
    try {
      let result;

      if (body instanceof FormData) {
        result = await axios({
          url: `${this.url}/${endPoint}`,
          method: "POST",
          data: body,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        const updatedBody = { ...body };
        Object.keys(updatedBody).forEach((key) => {
          if (updatedBody[key] === undefined || updatedBody[key] === null) {
            delete updatedBody[key];
          }
        });

        result = await axios({
          url: `${this.url}/${endPoint}`,
          method: "POST",
          data: updatedBody,
        });
      }

      return result;
    } catch (e) {
      const err = e as any;
      console.error("API Error", err?.response);

      if (err?.response?.status === 0 || err?.response?.status === 401) {
        throw new Error("Permissions denied");
      }

      if (err.response.data?.errorMessage) {
        throw new Error(err.response.data.errorMessage);
      }

      throw e;
    }
  }

  public static async postMileageRequest(request: IMileageRequest) {
    return this.post("requests/mileageRequest", request);
  }

  public static async postPublishQuotedRailRateRequest(
    request: IPublishQuotedRailRateRequest,
  ) {
    return this.post("requests/publishQuotedRailRateRequest", request);
  }

  public static async postRateRequest(request: FormData) {
    return this.post("requests/rateRequest", request);
  }

  // email to Gehad and Chole, Kara & Abe
  public static async postReviewRequest(request: IReviewRequest) {
    return this.post("requests/reviewRequest", request);
  }

  // email to Chance and Tianying
  public static async postApiErrorRequest(request: IErrorRequest) {
    return this.post("requests/errorRequest", request);
  }

  // email to Kara & Abe - add mode
  public static async postRailRateMissingRequest(request: IMissingRateRequest) {
    return this.post("requests/missingRateRequest", request);
  }

  public static async postCacheRefresh(
    resource: string,
    body: { [key: string]: any },
  ) {
    const endpoint = `cache-refresh?resource=${encodeURIComponent(resource)}`;
    return this.post(endpoint, body);
  }

  public static async postRequestForRailRate(request: IRailFreightRateRequest) {
    return this.post("requestrailrate", request);
  }
}
